// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LkpL","colBig":"styles_colBig__2WbwJ","colSmall":"styles_colSmall__1mOs1"};